import React, {PureComponent} from 'react'
import styled from 'styled-components'
import get from 'lodash/get'
import map from 'lodash/map'
import values from 'lodash/values'
import isEmpty from 'lodash/isEmpty'
// import filter from 'lodash/filter'
import {Link} from 'react-router-dom'
import {Icon, Header, Breadcrumb} from '../components'
import { toast } from 'react-toastify'
import {API_URL} from '../constants'
import axios from 'axios'
import * as moment from "moment";

// import * as Cookies from 'js-cookie'

const Container = styled.div`
  width: 100%;
  padding: 50px 16px 16px 16px; 
  max-width: 800px;
  margin: auto;
`
const Title = styled.h4`
  margin: 0;
  padding: 10px 0 3px 0;
`
const Wrapper = styled.div`
  display: flex;
  & > div{
    width: 50%;
    &:first-child{
      padding-right: 6px
    }
    &:nth-child(2){
      padding-left: 6px
    }
  }
`
const Note = styled.div`
  position: relative;
  font-size: 12px;
  color: #454545;
  padding-bottom: 6px;
  & > span{
    font-weight: 600;
  }
`
const ImageContainer = styled.div`
  width: 50px;
  height: 50px;
  overflow: hidden;
  border-radius: 4px;
`
const StyledText = styled.p`
  margin: 0 0 10px 0;
`
const ImageUpload = styled.div`
 display: flex;
 flex-wrap: wrap;
 & > div{
  width: 50px;
  height: 50px;
  border-radius:4px;
  margin: 0px 10px 10px 0px;
  background: #f3f3f3;
  border: 1px solid #f1f1f1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 20px;
  color: #020266;
  & > img{
    width: 50px;
    height: 50px;
  }
 }
`

const ButtonWrapper = styled.div`
  padding: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
`
const Button = styled.button`
  padding: 10px 25px;
  background: #020266;
  border: 1px solid #020266;
  border-radius: 4px;
  color: #fff;
  margin: 0 5px;
`


class VisitorPreview extends PureComponent{
  state={
    isLoading:true,
    historyViewList:{},
    reportsUrl:null,
    imageUrl:null,
    audioUrl:null,
    videoUrl:null,
    project:{}
  }

  componentDidMount=async()=>{
    const {match}=this.props
    get(match,'params.id') &&
    await axios.get(`/visitor/${get(match,'params.id')}`).then(async(res)=>{
      this.setState({
        historyViewList: get(res,'data.0'), 
        reportsUrl : JSON.parse(get(res,'data.0.reportsUrl')),
        imageUrl : JSON.parse(get(res,'data.0.imageUrl')),
        audioUrl : JSON.parse(get(res,'data.0.audioUrl')),
        videoUrl : JSON.parse(get(res,'data.0.videoUrl')),
        isLoading:false
      })
      // console.log('res------>>', res)
      const {data:project}= await axios.get(`/project-details/project/${get(res,'data.0.ProjectCode')}`)
      this.setState({project:project[0]})
      // console.log('project-------->>', project)
    }).catch(err=>{
        toast("Data not found ! ",{
          position: toast.POSITION.BOTTOM_CENTER,
        })
    })
  }

  

  render(){
    const {match}=this.props
    const {historyViewList,project, imageUrl, reportsUrl, audioUrl, videoUrl} = this.state

    const localData = get(match,'params.id') ? this.setState.historyViewList :JSON.parse(localStorage.getItem('draft') ? localStorage.getItem('draft') :"{")
    // console.log('--------->>', JSON.parse(localStorage.getItem('draft')),{imageUrl, audioUrl, videoUrl})
    // console.log('project------<<>>', project)

    return(
      <React.Fragment>
      <Header backIcon={true}/>
      <Container>
      <Breadcrumb>
      <Link to='/'>Home</Link>
      <Icon icon='rightArrow' width={10} height={10}/>
      <Link to='/form'>Inspection Form </Link>
      <Icon icon='rightArrow' width={10} height={10}/>
      Preview 
    </Breadcrumb>
      <Wrapper>
        <div>
          <Title>State</Title>
            <StyledText>{get(localData,'state.label') || get(historyViewList,'StateName')}</StyledText>
        </div>
        <div>
          <Title>District</Title>
            <StyledText>{get(localData,'district.label') || get(historyViewList,'DistrictName')}</StyledText>
        </div>
      </Wrapper>
      <Wrapper>
        <div>
          <Title>City</Title>
          <StyledText>{get(localData,'city.label')|| get(historyViewList,'CityName')}</StyledText>
        </div>
        <div>
          <Title>Project Code</Title>
          <StyledText>{get(localData,'project.value') || get(historyViewList,'ProjectCode') }</StyledText>
        </div>
      </Wrapper>

        <Note>
          <span>Note:</span> {get(project,'ProjectTitle')}
        </Note>
        <div>
          <Title>Visited Date</Title>
          <StyledText>{get(localData,'VisitedDate') || get(historyViewList,'VisitedDate') ?  moment(get(localData,'VisitedDate') || get(historyViewList,'VisitedDate')).format("DD-MMM-YYYY") :'-' }</StyledText>
        </div>
        {!isEmpty(get(localData,'imagesFile')) || !isEmpty(imageUrl) ? <Title>Upload Images</Title> : ''}
        <ImageUpload>
        {map(imageUrl ? imageUrl : values(get(localData,'imagesFile')), (item, idx)=> {
          return(
          <ImageContainer key={idx}> 
            <img alt="images" src={API_URL+'/images/'+item.fileName}/>
          </ImageContainer>
          )
        })}
        </ImageUpload>

        {!isEmpty(get(localData,'reportsFile')) || !isEmpty(imageUrl) ? <Title>Upload Reports</Title> : ''}
        <ImageUpload>
        {map(reportsUrl ? reportsUrl : values(get(localData,'reportsFile')), (item, idx)=> {
          return(
          <ImageContainer key={idx}> 
            <img alt="images" src={require('../static/doc-flat.png')}/>
          </ImageContainer>
          )
        })}
        </ImageUpload>

        {!isEmpty(get(localData,'audiosFile'))|| !isEmpty(audioUrl)  ? <Title>Upload Audio</Title> : ''}
        <ImageUpload>
        {map(audioUrl ? audioUrl : values(get(localData,'audiosFile')), (item, idx)=> {
          return(
            <div key={idx}> 
                <Icon icon='audio'/>
           </div>
          )
        })}
        </ImageUpload>

        {!isEmpty(get(localData,'videosFile')) || !isEmpty(videoUrl) ? <Title>Upload Videos</Title> : ''}
        <ImageUpload>
        {map(videoUrl ? videoUrl : values(get(localData,'videosFile')), (item, idx)=> {
          return(
            <div key={idx}> 
                <Icon icon='video'/>
           </div>
          )
        })}
        </ImageUpload>

        <Title>Description</Title>
        <Note>
        {get(localData,'description') || get(historyViewList,'Description')}
        </Note>
         
          {get(match,'params.id') && <ButtonWrapper>
            <Button onClick={()=> {
              // console.log('----->', historyViewList)
              const editData = {
                state:{
                label: get(historyViewList,'StateName'),
                value:get(historyViewList,'StateCode') 
                },
                district:{
                  label: get(historyViewList,'DistrictName'),
                  value:get(historyViewList,'DistrictCode') 
                  },
                component:{
                  label: get(historyViewList,'Component'),
                  value:get(historyViewList,'Component') 
                  },
                city:{
                  label: get(historyViewList,'CityName'),
                  value:get(historyViewList,'CityCode') 
                  },
                project:{
                  ...project,
                  label: get(historyViewList,'ProjectTitle'),
                  value:get(historyViewList,'ProjectCode')
                },
                VisitedDate:get(historyViewList,'VisitedDate'),
                imagesFile:{...imageUrl},
                reportsFile:{...reportsUrl},
                audiosFile:{...audioUrl},
                videosFile:{...videoUrl},
                description: get(historyViewList,'Description'),
              }
              this.props.history.push(`/form/${get(match,'params.id')}`)
              localStorage.setItem('editData', JSON.stringify(editData))

              }}>Edit</Button>
          </ButtonWrapper>}
      </Container>
      </React.Fragment>
    )
  }
}

export {VisitorPreview}